// Shared only by the public website. Nested map/dialog dismissals must not leave body locked.
let count = 0;
let originalOverflow = '';
export function lockPublicWebScroll() {
  if (count === 0) {
    originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  count++;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    count--;
    if (count === 0) document.body.style.overflow = originalOverflow;
  };
}
